import React from 'react';
import LoaderImg from '../assets/splash-screen-logo.gif';
import './common.css';
type LoaderProps = {
  showHide: boolean;
};
const Loader: React.FC<LoaderProps> = ({ showHide }) => {
  if (!showHide) {
    return null;
  }

  return (
    <div className='loader'>
      <img src={LoaderImg} alt='Loading...' />
    </div>
  );
};
export default Loader;
